import { IN_PERSON_TRAINING } from 'constants/actionTypes';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

export function toggleUpdateEmailConfirmation(
  { resource, changedAttributes } = { resource: null, changedAttributes: [] },
) {
  return (dispatch, getState) => {
    dispatch({
      type: IN_PERSON_TRAINING.EVENT_CHANGE_MANAGEMENT.TOGGLE_UPDATE_EMAIL,
      resource,
      changedAttributes,
    });
  };
}

export function toggleTrainerChangeConfirmation(session) {
  return {
    type: IN_PERSON_TRAINING.EVENT_CHANGE_MANAGEMENT
      .TOGGLE_CONFIRM_TRAINER_CHANGE,
    session,
  };
}

export function sendUpdateEmail() {
  return (dispatch, getState) => {
    const { eventChangeManagement } = getState();
    const { resource, changedAttributes } = eventChangeManagement.updateEmail;
    return new Promise((resolve, reject) => {
      request
        .postJSON(routes.IN_PERSON_TRAINING.UPDATE_EMAIL, {
          id: resource.id,
          type: resource.type,
          changed_attributes: changedAttributes,
        })
        .then(() => {
          dispatch(toggleUpdateEmailConfirmation());
          resolve();
        })
        .fail(reject);
    });
  };
}
